<template>
    <div v-if="tournament">
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">{{ tournament.name }}</h1>
                    </div>

                    <div class="col-2 text--right">
                        <a @click.prevent="handleBack('/')"class="btn btn--icon btn--white">
                            <i class="material-icons">close</i>
                        </a>
                    </div>
                </div>
            </div>
        </header>

        <div class="container">
            <h2 class="postbox__title text--center mb--md">Rules</h2>

            <div class="opacity--sm ml--md mr--md" v-html="tournament.regulations"></div>
        </div>
        <navigation></navigation>
    </div>
</template>

<script>

import AppHeader from "../partial/AppHeader";
import Navigation from "../partial/Navigation";
import api from "../../api/tournaments";
import internalBackRoute from "../../mixins/internalBackRoute";

export default {
name: "TournamentRules",
    components: {Navigation, AppHeader},
    mixins: [internalBackRoute],

    props: {
        tournamentId: {
            required: true
        }
    },

    data: function () {
        return {
            tournament: null,
        }
    },

    methods: {
        async loadTournament() {
            try {
                let response = await api.loadTournament(this.tournamentId)

                this.tournament = response.data.data
            } catch (e) {

            }
        }
    },

    created() {
        this.loadTournament()
    }
}
</script>
